import { Target, RelAttribute, ComponentType } from 'data-types-config';
import type { ExternalDestinationProps } from './ExternalDestination.types';

export const externalDestinationDefaults: Partial<ExternalDestinationProps> = {
  target: Target.Blank,
  rel: RelAttribute.PreventReferrerAndFollow,
  openInNewTab: true,
  componentType: ComponentType.External,
  isDisabled: false,
  isVisible: true,
  text: '',
};
